import React from "react";

/**
 * Thin authority ribbon — sits flush under the hero. No headlines.
 * Just a monospace line of irrefutable credentials. The Linear/Anthropic move.
 */
const SIGNALS = [
  "BACKED BY 18+ YEARS OF ENTERPRISE SYSTEMS",
  "INTIME IT SERVICES PVT. LTD.",
  "ICMAI STRATEGIC PARTNER",
  "NASSCOM-JUDGED INAUGURAL EDITION",
  "HIT CO-FUNDED ARENA",
];

export default function AuthorityRibbon() {
  return (
    <section
      className="border-t border-b hairline"
      style={{ background: "var(--ink)" }}
      data-testid="authority-ribbon"
    >
      <div className="container-edge h-12 md:h-14 flex items-center gap-6 md:gap-10 overflow-x-auto">
        {SIGNALS.map((s, i) => (
          <span
            key={s}
            className="font-mono text-[10.5px] md:text-[11px] whitespace-nowrap"
            style={{
              color: i % 2 === 0 ? "rgba(250,250,247,0.78)" : "var(--accent-gold)",
              letterSpacing: "0.18em",
            }}
          >
            {s}
          </span>
        ))}
      </div>
    </section>
  );
}
